
import { Component, Watch, Prop } from 'vue-property-decorator';
import Vue from 'vue';

import config from '../../../config';

import WithRender from './carousel.tpl.html';
import { Performer, PerformerAvatar } from 'sensejs/performer/performer.model';
import { getSliderImages } from '../../../util';

import './carousel.scss';

@WithRender
@Component
export default class Carousel extends Vue {

    getSliderImages = getSliderImages;
    touchStart: number = 0;

    @Prop({
        required: true,
        type: Array
    })
    photos: PerformerAvatar[];

    @Prop({
        required: true,
        type: Object
    })
    performer: object;

    @Prop({
        required: true,
        type: Number
    })
    currentImage: number;

    get isLast(){
        return this.$props.currentImage === this.$props.photos.length - 1;
    }

    get isFirst(){
        return this.$props.currentImage === 0;
    }

    mounted(){
        if(this.photos.length === 1){
            this.navigateTo('previous');
        }
    }

    navigateTo(direction: string, index?: number){
        this.$emit('navigateTo', direction, index);
    }

    onTouchStart(evt: TouchEvent){
        this.touchStart = evt.touches[0].pageX;
    }

    onTouchEnd(evt: TouchEvent){
        const touchDifference = this.touchStart - evt.changedTouches[0].pageX;

        if(touchDifference > 75){
            this.navigateTo('next');
        } else if(touchDifference < -75){
            this.navigateTo('previous');
        }
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/pages/carousel/carousel.ts